import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { T, t } from '@sm/intl';
import { Box } from '@wds/box';
import { Checkbox } from '@wds/checkbox';
import { Menu } from '@wds/menu';
import { Typography } from '@wds/typography';
import { IconMoreAndroid } from '@wds/icons';
import LinkStyleButton from '../../shared/LinkStyleButton';
import { ALL_FILTER_ID_BLANK } from '../../constants';
import { useFilters } from '../../Context';
export const COPY = {
  edit: {
    id: 'OpenEndedCoding.ThemeRow.edit',
    defaultMessage: 'Edit',
    description: '[Type: Header][Vis: med] - Edit button for themes'
  },
  delete: {
    id: 'OpenEndedCoding.ThemeRow.delete',
    defaultMessage: 'Delete',
    description: '[Type: Header][Vis: med] - Delete button for themes'
  },
  iconMoreAndroid: {
    id: 'OpenEndedCoding.ThemeRow.iconMoreAndroid',
    defaultMessage: 'theme options',
    description: '[Type: Label][Vis: low] - icon to show theme options'
  }
};
const useStyles = createUseStyles(() => {
  return {
    // hide the menu unless we hover on the row
    container: {
      '&:hover, &:focus': {
        '& $hide': {
          visibility: 'visible'
        }
      }
    },
    hide: {
      visibility: 'hidden'
    }
  };
});
const ThemeRow = ({
  theme,
  id,
  count,
  onClickDelete,
  onClickEdit,
  handleThemeSelect
}) => {
  const classes = useStyles();
  const [showMenu, setShowMenu] = useState(false);
  const {
    selectedThemes
  } = useFilters();
  const trigger = _jsx(Box, {
    className: classes.hide,
    "data-testid": "MenuButton",
    children: _jsx(LinkStyleButton, {
      children: _jsx(IconMoreAndroid, {
        title: t(COPY.iconMoreAndroid),
        size: "sm",
        color: "darkMuted"
      })
    })
  });
  return _jsxs(Box, {
    className: classes.container,
    display: "flex",
    justifyContent: "space-between",
    children: [_jsxs(Box, {
      display: "flex",
      children: [_jsx(Checkbox, {
        "data-testid": `Checkbox-${id}`,
        id: `checkbox-${id}`,
        value: id,
        onChange: () => handleThemeSelect(id),
        checked: selectedThemes.includes(id) && !selectedThemes.includes(ALL_FILTER_ID_BLANK)
      }), _jsx(Box, {
        ml: 2,
        children: _jsx(Typography, {
          component: "div",
          variant: "bodySm",
          color: "dark",
          children: theme
        })
      })]
    }), _jsxs(Box, {
      display: "inline-flex",
      alignItems: "center",
      children: [_jsx(Typography, {
        component: "div",
        variant: "bodySm",
        color: "dark",
        children: count
      }), _jsx(Box, {
        ml: 2,
        mb: 1,
        children: _jsxs(Menu, {
          placement: "bottom-right",
          show: showMenu,
          menuTrigger: trigger,
          children: [_jsx(Menu.Item, {
            onClick: () => {
              setShowMenu(false);
              onClickEdit();
            },
            children: _jsx(T, {
              desc: COPY.edit
            })
          }), _jsx(Menu.Item, {
            onClick: () => {
              setShowMenu(false);
              onClickDelete();
            },
            children: _jsx(T, {
              desc: COPY.delete
            })
          })]
        })
      })]
    })]
  });
};
export default ThemeRow;